export const ListVehicle = {
  title: 'Lista de Matriculas',
  labelRegistration: 'Matriculas',
  labelDriver: 'Motoristas',
  tooltipOp1: 'Eliminar Matricula'
}



// WEBPACK FOOTER //
// ./src/translations/pt/miscellaneous/ListVehicle.js